export type Locale = 'vi-VN' | 'en-US'

const messages = {
  'vi-VN': {
    'app.loadingSession': 'Đang tải phiên đăng nhập…',
    'app.loadingWorkspace': 'Đang tải workspace…',
    'auth.login': 'Đăng nhập',
    'auth.signup': 'Tạo tài khoản',
    'auth.email': 'Email',
    'auth.password': 'Mật khẩu',
    'auth.logout': 'Đăng xuất',
    'common.refresh': 'Làm mới',
    'common.cancel': 'Hủy',
    'common.save': 'Lưu',
    'nav.overview': 'Tổng quan',
    'nav.campaigns': 'Campaign',
    'nav.creatorOperations': 'Creator operations',
    'nav.clientDashboard': 'Client dashboard',
    'nav.reports': 'Báo cáo',
    'campaign.new': 'Campaign mới',
    'campaign.status.draft': 'Bản nháp',
    'campaign.status.configured': 'Đã cấu hình',
    'campaign.status.active': 'Đang chạy',
    'campaign.status.paused': 'Tạm dừng',
    'campaign.status.completed': 'Hoàn thành',
    'campaign.status.archived': 'Lưu trữ',
    'studio.eyebrow': 'ROLE & USER CUSTOMIZATION STUDIO',
    'studio.title': 'Users · Role Preset · User Override · Permission & Scope',
    'studio.subtitle': 'Mọi thay đổi đi qua registry, entitlement, validation và server-authorized audit.',
    'studio.searchLabel': 'Tìm user theo User ID, Username hoặc display name',
    'studio.searchPlaceholder': 'User ID / Username / display name',
    'studio.searchAction': 'Tìm kiếm',
    'studio.loading': 'Đang tải…',
    'studio.noResults': 'Không có user phù hợp trong workspace này.',
    'studio.noUsername': 'chưa-có-username',
    'studio.defaultView': 'Default view',
    'studio.fromRole': 'Theo role/workspace',
    'studio.modules': 'Modules',
    'studio.noModules': 'Không có module enabled',
    'studio.overrideActive': 'Có User Override',
    'studio.roleDefault': 'Theo Role Default',
    'studio.rolePreset': 'ROLE PRESET',
    'studio.role': 'Role',
    'studio.presetVersion': 'Preset version',
    'studio.permissionScope': 'PERMISSION & SCOPE',
    'studio.workspaceScope': 'Workspace scope',
    'studio.membership': 'Membership',
    'studio.capabilities': 'Capabilities từ Role Preset',
    'studio.compare': 'COMPARE WITH ROLE DEFAULT',
    'studio.before': 'Trước',
    'studio.after': 'Sau',
    'studio.override': 'Override',
    'studio.legacyRole': 'Legacy role',
    'studio.userOverride': 'USER OVERRIDE',
    'studio.overrideHelp': 'Chỉ key đã được configuration schema cho phép mới có thể active; protected invariant luôn thắng override.',
    'studio.reason': 'Lý do thay đổi',
    'studio.reasonPlaceholder': 'Bắt buộc cho audited mutation',
    'studio.confirm': 'Tôi đã kiểm tra diff và xác nhận thay đổi.',
    'studio.updateRole': 'Cập nhật Role Preset',
    'studio.activateOverride': 'Kích hoạt User Override',
    'studio.roleUpdated': 'Role Preset đã được cập nhật và ghi audit.',
    'studio.overrideUpdated': 'User Override đã được version hóa và kích hoạt.',
    'studio.preview': 'PREVIEW AS USER · READ-ONLY',
    'studio.previewAction': 'Mở Preview as User',
    'studio.previewPurpose': 'Purpose',
    'studio.previewScope': 'Object scope',
    'studio.previewNavigation': 'Navigation đã resolve',
    'studio.previewHome': 'Home sections đã resolve',
    'studio.previewActions': 'Action availability',
    'studio.previewFields': 'Field visibility',
    'studio.previewProvenance': 'Configuration provenance',
    'studio.previewWarnings': 'Cảnh báo configuration',
    'studio.previewNoWarnings': 'Không có cảnh báo.',
    'privacy.eyebrow': 'DATA & AI PREFERENCES',
    'privacy.title': 'Quyền sử dụng dữ liệu và AI',
    'privacy.subtitle': 'Mỗi quyền được quản lý riêng theo purpose, data category và policy version; không dùng một consent boolean chung.',
    'privacy.reason': 'Lý do thay đổi preference',
    'privacy.reasonPlaceholder': 'Bắt buộc để tạo audit evidence',
    'privacy.revokeHelp': 'Bạn có thể rút quyền đã cấp. Việc rút quyền chặn các lần sử dụng dữ liệu đủ điều kiện trong tương lai theo policy hiện hành.',
    'privacy.currentStatus': 'Trạng thái hiện tại',
    'privacy.effectiveAt': 'Có hiệu lực từ',
    'privacy.grant': 'Cho phép',
    'privacy.deny': 'Từ chối',
    'privacy.revoke': 'Rút quyền',
    'privacy.updated': 'Data & AI Preference đã được cập nhật và ghi audit.',
    'privacy.noPolicies': 'Chưa có policy đang active cho workspace này.',
    'privacy.status.granted': 'Đã cho phép',
    'privacy.status.denied': 'Đã từ chối',
    'privacy.status.revoked': 'Đã rút quyền',
    'privacy.status.missing': 'Chưa có quyết định',
    'privacy.policy.aiAssistance': 'AI assistance personalization',
    'privacy.policy.aiAssistanceHelp': 'Cho phép sử dụng dữ liệu thuộc AI assistance cho mục đích personalization đã nêu; không mở rộng sang purpose khác.',
    'privacy.policy.performance': 'Performance measurement',
    'privacy.policy.performanceHelp': 'Cho phép sử dụng PerformanceSnapshot và dữ liệu hiệu suất cho measurement theo policy version này.',
    'privacy.policy.contentProcessing': 'Content processing',
    'privacy.policy.contentProcessingHelp': 'Cho phép xử lý content submission cho mục đích vận hành đã nêu; internal fields vẫn tuân field-level visibility.',
    'role.managerPactlane': 'Manager Pactlane',
    'role.managerAgencyCreator': 'Manager / Agency Creator',
    'role.creatorTalent': 'Creator / Talent',
    'role.brand': 'Brand',
  },
  'en-US': {
    'app.loadingSession': 'Loading session…',
    'app.loadingWorkspace': 'Loading workspace…',
    'auth.login': 'Sign in',
    'auth.signup': 'Create account',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.logout': 'Sign out',
    'common.refresh': 'Refresh',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'nav.overview': 'Overview',
    'nav.campaigns': 'Campaigns',
    'nav.creatorOperations': 'Creator operations',
    'nav.clientDashboard': 'Client dashboard',
    'nav.reports': 'Reports',
    'campaign.new': 'New campaign',
    'campaign.status.draft': 'Draft',
    'campaign.status.configured': 'Configured',
    'campaign.status.active': 'Active',
    'campaign.status.paused': 'Paused',
    'campaign.status.completed': 'Completed',
    'campaign.status.archived': 'Archived',
    'studio.eyebrow': 'ROLE & USER CUSTOMIZATION STUDIO',
    'studio.title': 'Users · Role Preset · User Override · Permission & Scope',
    'studio.subtitle': 'Every change passes registry, entitlement, validation, and server-authorized audit controls.',
    'studio.searchLabel': 'Find a user by User ID, Username, or display name',
    'studio.searchPlaceholder': 'User ID / Username / display name',
    'studio.searchAction': 'Search',
    'studio.loading': 'Loading…',
    'studio.noResults': 'No matching user in this workspace.',
    'studio.noUsername': 'no-username',
    'studio.defaultView': 'Default view',
    'studio.fromRole': 'From role/workspace',
    'studio.modules': 'Modules',
    'studio.noModules': 'No enabled modules',
    'studio.overrideActive': 'User Override active',
    'studio.roleDefault': 'Using Role Default',
    'studio.rolePreset': 'ROLE PRESET',
    'studio.role': 'Role',
    'studio.presetVersion': 'Preset version',
    'studio.permissionScope': 'PERMISSION & SCOPE',
    'studio.workspaceScope': 'Workspace scope',
    'studio.membership': 'Membership',
    'studio.capabilities': 'Role Preset capabilities',
    'studio.compare': 'COMPARE WITH ROLE DEFAULT',
    'studio.before': 'Before',
    'studio.after': 'After',
    'studio.override': 'Override',
    'studio.legacyRole': 'Legacy role',
    'studio.userOverride': 'USER OVERRIDE',
    'studio.overrideHelp': 'Only keys allowed by the configuration schema can activate; protected invariants always override customization.',
    'studio.reason': 'Change reason',
    'studio.reasonPlaceholder': 'Required for audited mutation',
    'studio.confirm': 'I reviewed the diff and confirm this change.',
    'studio.updateRole': 'Update Role Preset',
    'studio.activateOverride': 'Activate User Override',
    'studio.roleUpdated': 'Role Preset updated and audited.',
    'studio.overrideUpdated': 'User Override versioned and activated.',
    'studio.preview': 'PREVIEW AS USER · READ-ONLY',
    'studio.previewAction': 'Open Preview as User',
    'studio.previewPurpose': 'Purpose',
    'studio.previewScope': 'Object scope',
    'studio.previewNavigation': 'Resolved navigation',
    'studio.previewHome': 'Resolved Home sections',
    'studio.previewActions': 'Action availability',
    'studio.previewFields': 'Field visibility',
    'studio.previewProvenance': 'Configuration provenance',
    'studio.previewWarnings': 'Configuration warnings',
    'studio.previewNoWarnings': 'No warnings.',
    'privacy.eyebrow': 'DATA & AI PREFERENCES',
    'privacy.title': 'Data use and AI preferences',
    'privacy.subtitle': 'Each decision is scoped by purpose, data category, and policy version instead of a single consent boolean.',
    'privacy.reason': 'Preference change reason',
    'privacy.reasonPlaceholder': 'Required for audit evidence',
    'privacy.revokeHelp': 'You can revoke a granted permission. Revocation blocks future eligible use under the applicable policy.',
    'privacy.currentStatus': 'Current status',
    'privacy.effectiveAt': 'Effective at',
    'privacy.grant': 'Allow',
    'privacy.deny': 'Deny',
    'privacy.revoke': 'Revoke',
    'privacy.updated': 'Data & AI Preference updated and audited.',
    'privacy.noPolicies': 'No active policy is available for this workspace.',
    'privacy.status.granted': 'Allowed',
    'privacy.status.denied': 'Denied',
    'privacy.status.revoked': 'Revoked',
    'privacy.status.missing': 'No decision',
    'privacy.policy.aiAssistance': 'AI assistance personalization',
    'privacy.policy.aiAssistanceHelp': 'Allows AI-assistance data to be used for the stated personalization purpose only; it does not extend to other purposes.',
    'privacy.policy.performance': 'Performance measurement',
    'privacy.policy.performanceHelp': 'Allows PerformanceSnapshot and performance data to be used for measurement under this policy version.',
    'privacy.policy.contentProcessing': 'Content processing',
    'privacy.policy.contentProcessingHelp': 'Allows content submissions to be processed for the stated operational purpose; internal fields remain field-visibility controlled.',
    'role.managerPactlane': 'Manager Pactlane',
    'role.managerAgencyCreator': 'Manager / Agency Creator',
    'role.creatorTalent': 'Creator / Talent',
    'role.brand': 'Brand',
  },
} as const

export type MessageKey = keyof typeof messages['vi-VN']

export const defaultLocale: Locale = 'vi-VN'

export function translate(key: MessageKey, locale: Locale = defaultLocale): string {
  return messages[locale][key] ?? messages[defaultLocale][key]
}

export function formatNumber(value: number, locale: Locale = defaultLocale): string {
  return new Intl.NumberFormat(locale).format(value)
}

export function formatDateTime(value: string | number | Date, locale: Locale = defaultLocale, timeZone = 'Asia/Ho_Chi_Minh'): string {
  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone,
  }).format(new Date(value))
}

export function formatCurrency(value: number, currency: string, locale: Locale = defaultLocale): string {
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value)
}
